module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('strong', [_vm._v("Books by Janet Dailey")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The Great Alone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Glory Game")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Pride of Hannah Wade")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Silver Wings, Santiago Blue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Calder Born, Calder Bred")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stands a Calder Man")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This Calder Range")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This Calder Sky")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Best Way to Lose")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the Love of God")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Foxfire Light")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Hostage Bride")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Lancaster Men")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leftover Love")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mistletoe & Holly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Second Time")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Separate Cabins")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Terms of Surrender")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Western Man")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nightway")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ride the Thunder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Rogue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Touch the Wind")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Published by POCKET BOOKS")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxtext"
  }, [_vm._v("Most Pocket Books are available at special quantity discounts for bulk purchases for sales promotions, premiums or fund raising. Special books or book excerpts can also be created to fit specific needs.")]), _vm._v(" "), _c('p', {
    staticClass: "boxtext"
  }, [_vm._v("For details write the office of the Vice President of Special Markets, Pocket Books, 1230 Avenue of the Americas, New York, New York 10020.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 66
// module chunks = 0